import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {get_tax_credit_app_info, find_funding_round_by_org_id} from "../graphql/getAppInfo";
import {Apollo} from "apollo-angular";
import {FormControl} from "@angular/forms";
import {Observable, startWith} from "rxjs";
import {map} from "rxjs/operators";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import moment from 'moment';

@Component({
    selector: 'app-add-tax-credit-app-confirmation',
    templateUrl: './add-tax-credit-app-confirmation.component.html',
    styleUrls: ['./add-tax-credit-app-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddTaxCreditAppConfirmationComponent implements OnInit{
  creditTypes: any;
  creditDesignations: any;
  hdas: any;
  originalHDAS: any;
  orgid: string = '';
  loaded: boolean = false;
  isFundingRound: boolean | null = null;
  isAwarded: boolean | null = null;
  myControl = new FormControl('');
  filteredOptions: Observable<string[]>
  creditType: any;
  creditsList: any = [];
  fundingRounds: any = [];
  yearIndex: number | null = null;
  roundIndex: number | null = null;
  amount: number | null = null;
  requestDate: string | null = null;

  constructor(
    private _snackBar: MatSnackBar,
    private apollo: Apollo,
    public dialogRef: MatDialogRef<AddTaxCreditAppConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) data: {
    }
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.apollo
      .query({
        query: get_tax_credit_app_info
      })
      .subscribe(
        ({ data }) => {
          // @ts-ignore
          let results: any = data;
          this.creditTypes = results.taxCreditTypes;
          this.creditDesignations = results.taxCreditDesignations;
          this.originalHDAS = results.HDAS
          this.hdas = this.formatHDAS(results.HDAS);
          this.formatTaxCreditTypes();
          this.filteredOptions = this.myControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '')),
          );
          this.loaded = true;
        }, error => {
          this.dialogRef.close();
        }
      );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.hdas.filter((option: string) => option.toLowerCase().includes(filterValue));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  formatHDAS(data: any): string[]{
    let format: string[] = [];
    for(let i = 0; i < data.length; i++){
      format.push(data[i].entity.organization.name);
    }
    format.sort();
    return format;
  }

  formatTaxCreditTypes(){
    for(let i = 0; i < this.creditTypes.length; i++){
      if(this.creditTypes[i].level === 'Federal' && this.creditTypes[i].name === 'LIHTC'){
        for(let j = 0; j < this.creditDesignations.length; j++){
          this.creditsList.push({
            name: this.creditTypes[i].level + " " + this.creditTypes[i].name + " - " + this.creditDesignations[j].name,
            typeid: this.creditTypes[i].id,
            designationid: this.creditDesignations[j].id
          });
        }
      } else {
        this.creditsList.push({
          name: this.creditTypes[i].level + " " + this.creditTypes[i].name,
          typeid: this.creditTypes[i].id,
          designationid: null
        });
      }
    }

    this.creditsList.sort( this.compare );

    //Find LIHTC credits and put them at beginning
    //of array
    let lihtc4: number = 0;
    let lihtc9: number = 0;
    for(let i = 0; i < this.creditsList.length; i++){
      if(this.creditsList[i].name.includes('LIHTC - 4%')){
        lihtc4 = i;
      } else if(this.creditsList[i].name.includes('LIHTC - 9%')){
        lihtc9 = i;
      }
    }

    let temp9 = this.creditsList[lihtc9];
    let temp4 = this.creditsList[lihtc4]
    this.creditsList.splice(lihtc9, 1);
    this.creditsList.splice(lihtc4, 1);
    this.creditsList.unshift(temp4, temp9);
  }

  compare(a: any, b:any){
    if ( a.name < b.name ){
      return -1;
    }
    if ( a.name > b.name ){
      return 1;
    }
    return 0;
  }

  //this is to move objects within an array
  array_move(arr: any, old_index: number, new_index: number) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  checkFundingRound(){
    this.yearIndex = null;
    this.roundIndex = null;
    this.orgid = '';
    if(this.myControl.value && this.myControl.value !== ''){
      let temporg = '';
      for(let i = 0; i < this.originalHDAS.length; i++){
        if(this.myControl.value === this.originalHDAS[i].entity.organization.name){
          temporg = this.originalHDAS[i].entity.organization.id;
          break;
        }
      }
      this.orgid = temporg;

      if(this.isFundingRound && this.orgid !== ''){
        this.fundingRounds = [];
        this.apollo
          .query({
            query: find_funding_round_by_org_id,
            variables: {
              organization_id: this.orgid
            }
          })
          .subscribe(
            ({ data }) => {
              // @ts-ignore
              this.fundingRounds = this.formatFundingRounds(data.findFundingRoundByOrgID);
            }
          );
      } else if(this.isFundingRound && this.orgid === '') {
        this.openSnackBar('Warning: Could not search for Funding Round. Please select an existing HDA from the dropdown.')
      }
    } else {
      this.fundingRounds = [];
    }
  }

  formatFundingRounds(data: any): any{
    let years: string[] = [];
    let formatted: any = [];
    if(data && data.length > 0){
      for(let i = 0; i < data.length; i++){
        if(!years.includes(data[i].year)){
          years.push(data[i].year);
        }
      }

      years.sort().reverse();

      for(let i = 0; i < years.length; i++){
        let rounds = [];
        for(let j = 0; j < data.length; j++){
          if(years[i] === data[j].year){
            rounds.push({
              id: data[j].id,
              number: data[j].number,
              award: data[j].award_date ? moment
                .utc(data[j].award_date)
                .format('MM/DD/YYYY') : 'N/A',
              due: data[j].due_date ? moment
                .utc(data[j].due_date)
                .format('MM/DD/YYYY') : 'N/A'
            });
          }
        }
        if(rounds.length > 0){
          rounds.sort( this.compare );

          formatted.push({
            year: years[i],
            rounds: rounds
          });
        }
      }
    }
    return formatted;
  }

  compareNumbers(a: any, b:any){
    if ( a.number < b.number ){
      return -1;
    }
    if ( a.number > b.number ){
      return 1;
    }
    return 0;
  }

  clearData(){
    this.myControl.setValue('');
    this.orgid = '';
    this.yearIndex = null;
    this.roundIndex = null;
    this.creditType = null;
    this.fundingRounds = [];
  }

  openSnackBar(message: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-warning'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 7000;
    this._snackBar.open(message, 'Ok', config);
  }
}
